import PlatformError from "../PlatformError";

export default new PlatformError("ERROR", "OS / Browser not allowed", "Screenout", "OS / Browser not allowed.", "app.error.osbrowsernotallowed")